import React, { useState } from 'react'
import Whatsapp from './Whatsapp'
export default function Main({ admin }) {
    const [type, setType] = useState("whatsapp")

    const handleType = (type) => {
        setType(type)
    }
    return (
        <>
            <div className='container-fluid details-new' style={{ marginTop: '50px' }}>
                <div className='btn-group btn-grp-own'>
                    <button onClick={() => handleType("whatsapp")} className="btn btn-outline-primary" style={{ color: type === "whatsapp" ? "#fff" : "#000", background: type === "whatsapp" ? "rgb(6, 66, 84)" : 'rgb(241, 247, 255)', padding: '10px', borderRadius: '5px', fontSize: '15px' }}>
                        Whatsapp
                    </button>
                </div>

            </div>

            {
                type == "whatsapp" ?
                    <Whatsapp />
                    : ''}
        </>
    )
}
